import React, { useContext } from 'react';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';
import BlogImage from '../../assetss/img/blog1.webp';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import moment from 'moment';
import { CommonContext } from '../../context';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const LatestArticles = () => {
    const { indexData } = useContext(CommonContext);

    const navigate = useNavigate();

    const settingLatest = {
        dots: true,
        infinite: indexData?.newsData?.length > 3,
        speed: 500,
        slidesToShow: indexData?.newsData?.length > 3 ? 3 : indexData?.newsData?.length,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: indexData?.newsData?.length > 2 ? 2 : indexData?.newsData?.length,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: indexData?.newsData?.length > 1 ? 1 : indexData?.newsData?.length,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const handleCardClick = (post) => {
        // navigate(`/news-details`, { state: row });
        const nSlug = post?.title
            ?.trim()
            .replace(/[^a-zA-Z0-9\s]/g, '')
            .replace(/\s+/g, '-')
            .toLowerCase();

        const stateParam = btoa(JSON.stringify({ id: post?.id }));

        const url = `/news-details/${nSlug}?state=${stateParam}`;
        navigate(url);
    };
    return (
        <section className="latest-articles">
            <Container>
                <Row className="text-center mb-4">
                    <Col md="12">
                        {/* <div className="line"><span>NEWS UPDATES</span></div> */}
                        <h2 className="newsletter-title">Latest News and <span className="highlight">Annocements </span></h2>
                        <p className="newsletter-text d-none">
                            As per Bye-Laws of the Institution of Valuers duly amended, effective and enforceable w.e.f. 14/05/2022, the council for the years 2025 - 27 shall be formed through election. The Vacancies to be filled up are mentioned below.
                        </p>
                    </Col>
                </Row>
                <Slider {...settingLatest}>
                    {indexData?.newsData && indexData?.newsData.length > 0 && indexData?.newsData.map((row, index) => (
                        <>
                            <Card className="article-card" onClick={() => handleCardClick(row)}>
                                <img src={row.image ? `${process.env.REACT_APP_BASE_URL}download/${row?.image}?pathName=news` : 'https://via.placeholder.com/150'} alt="News thumbnail" className="article-image" />
                                <CardBody>
                                    <div className="article-meta">
                                        <span className="article-category">NEWS</span> / <span className="article-date">{row?.created_at ? moment(row?.created_at).format('DD MMM YYYY') : 'NA'}</span>
                                    </div>
                                    <h3 className="article-title">{row.title}</h3>
                                    {/* <p className="article-description">{row.description}</p> */}
                                    {/* <Button color="primary" className="read-more-btn" onClick={() => navigate(article.link)}>Read More</Button> */}
                                    <div className="interaction-buttons">
                                        <Button className="learn-more-link" onClick={() => handleCardClick(row)}>
                                            Read More <FontAwesomeIcon icon={faArrowRight} className="arrow-icon" />
                                            {/* </a> */}
                                        </Button>
                                    </div>
                                </CardBody>
                            </Card>
                        </>
                    ))}
                </Slider>
            </Container>
        </section>
    );
};

export default LatestArticles;
